import {Component, OnDestroy, OnInit} from '@angular/core';
import {ICategoryDevice} from '@entities/thiet-bi/thiet-bi.model';
import {ITEMS_PER_PAGE, PAGE_SIZE_OPTIONS} from '@app/shared';
import {Subscription} from 'rxjs';
import {JhiAlertService, JhiEventManager, JhiParseLinks} from 'ng-jhipster';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {ThietBiService} from '@entities/thiet-bi/thiet-bi.service';
import {HttpResponse} from '@angular/common/http';
import {MatTableDataSource} from '@angular/material/table';
import {PageEvent} from '@angular/material/paginator';
import {DOMAIN_IMAGE_URL} from '@shared/constants/domain';

@Component({
  selector: 'app-danh-muc-thiet-bi',
  templateUrl: './danh-muc-thiet-bi.component.html',
  styleUrls: ['./danh-muc-thiet-bi.component.scss'],
})
export class DanhMucThietBiComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'tenThuongMai',
    'loaiThietBi',
    'SKU',
    'nhaSanXuat',
    'taiLieu',
    'tonKho',
    'action',
  ];
  dataSource: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  currentSearch: string;
  itemsPerPage: any;
  ELEMENT_DATA: ICategoryDevice[];
  pageSizeOptions: number[];
  routeData: any;
  eventSubscriber: Subscription;
  links: any;
  totalItems: any;
  queryCount: any;
  DOMAIN_IMAGE_URL: string;
  noData: boolean;
  isLoading = true;

  constructor(
    private alertService: JhiAlertService,
    private activatedRoute: ActivatedRoute,
    private parseLinks: JhiParseLinks,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private thietBiService: ThietBiService,
    private translate: TranslateService,
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.ELEMENT_DATA = [];
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.pageSizeOptions = PAGE_SIZE_OPTIONS;
    this.DOMAIN_IMAGE_URL = DOMAIN_IMAGE_URL;
    this.routeData = this.activatedRoute.data.subscribe(({pagingParams}) => {
      this.page = pagingParams.page;
      this.previousPage = pagingParams.page;
      this.reverse = pagingParams.ascending;
      this.predicate = pagingParams.predicate;
    });
  }

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.thiet-bi.danh-muc-thiet-bi.Danh mục thiết bị_title',
      ),
    );
    this.loadAll();
    this.changeListCategoryDevice();
  }

  ngOnDestroy() {
    this.eventManager.destroy(this.eventSubscriber);
  }

  changeListCategoryDevice() {
    this.eventSubscriber = this.eventManager.subscribe(
      'categoryDeviceModification',
      (response) => this.loadAll(),
    );
  }

  loadAll() {
    this.isLoading = true;
    if (this.currentSearch) {
      this.thietBiService
        .listCategoryDevice({
          page: this.page - 1,
          q: this.currentSearch,
          size: this.itemsPerPage,
          sort: this.sort(),
        })
        .subscribe(
          (res: HttpResponse<ICategoryDevice[]>) =>
            this.onSuccess(res.body, res.headers),
          (res: HttpResponse<any>) => this.onError(res.body),
        );
      return;
    }
    this.thietBiService
      .listCategoryDevice({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort(),
      })
      .subscribe(
        (res: HttpResponse<ICategoryDevice[]>) =>
          this.onSuccess(res.body, res.headers),
        (res: HttpResponse<any>) => this.onError(res.body),
      );
  }

  search(query) {
    if (!query) {
      return this.clear();
    }

    this.page = 1;
    this.currentSearch = query;

    this.loadAll();
  }

  clear() {
    this.page = 1;
    this.currentSearch = '';

    this.loadAll();
  }

  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.loadAll();
  }

  private sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  private onSuccess(data: any, headers: any) {
    this.isLoading = false;
    this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = headers.get('X-Total-Count');
    this.queryCount = this.totalItems;
    this.ELEMENT_DATA = data;
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    if (data.length === 0) {
      this.noData = true;
    } else {
      this.noData = false;
    }
  }

  private onError(error: any) {
    this.isLoading = false;
    this.alertService.error(error.error, error.message, null);
  }
}
